import $ from 'jquery';
import { addListeners, removeListeners } from './listeners';
import { addInitialScroll } from './scroll';
import state from './state';
import {
	getBlockDataById,
	setSlidesWidthAndHeight,
	shouldRepeat,
	whenEditorIsReady,
	isGutenbergActive
} from './utils';

// Wait for both window and WordPress to be ready
function initializeWhenReady() {
    if (typeof window.wp === 'undefined') {
        // If running outside WordPress, wait a bit and try again
        setTimeout(initializeWhenReady, 100);
        return;
    }

    if (!isGutenbergActive()) {
        startSliders();
    } else {
        whenEditorIsReady().then(() => {
            setTimeout(() => {
                startSliders();
            }, 1500);
        });
    }
}

// Replace window.load with document ready and WordPress ready check
$(document).ready(function() {
    initializeWhenReady();
});

export function startSliders() {
	const $sliders = $( '.ae-block-dynamic-slider' );

	$sliders.each( initSlider );
}

export function startSlider( id ) {
	$( `#${id}` ).each( initSlider );
}

export function initSlider() {
	const slider = $( this );
	const sliderId = slider.attr( 'id' );

	removeListeners( slider );

	state.setState( sliderId, {});
	const data = getBlockDataById( sliderId );
	state.setState( sliderId, data );

	addListeners( slider );
	addInitialScroll( slider );
	setSlidesWidthAndHeight( sliderId );

	shouldRepeat( slider );
}
